import _ from "lodash";

import { ExpandMoreIcon, InfoOutlinedIcon } from "icons";
import { colors } from "theme/palette";

import Accordion, {
  AccordionDetails,
  AccordionSummary,
} from "components/Accordion";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

import PDFEmbed from "entities/File/components/PDFEmbed";
import { IProformaPDF, ProformaPDFFileStatus } from "entities/Memo/sdk";

export interface IAppendixAccordion {
  tooltip: string;
  proformaPDF?: IProformaPDF;
}
const AppendixAccordion = ({ tooltip, proformaPDF }: IAppendixAccordion) => (
  <Accordion defaultExpanded>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{ backgroundColor: colors.blue10 }}
    >
      <Text
        variant="text1"
        sx={{
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        Appendix
        <Tooltip title={tooltip} placement="top" enterDelay={0}>
          <InfoOutlinedIcon sx={{ height: "20px", width: "20px" }} />
        </Tooltip>
      </Text>
    </AccordionSummary>
    <AccordionDetails
      sx={{
        height:
          proformaPDF?.status === ProformaPDFFileStatus.SUCCEEDED
            ? "80vh"
            : undefined,
      }}
    >
      {!_.isNil(proformaPDF?.id) ? (
        <>
          {proformaPDF?.status === ProformaPDFFileStatus.SUCCEEDED && (
            <PDFEmbed
              key={proformaPDF?.file?.signed_url}
              pdfFileUrl={proformaPDF?.file?.signed_url}
              focusedQuoteClearanceCallback={() => {}}
              hideZoomControls
            />
          )}
          {proformaPDF?.status === ProformaPDFFileStatus.IN_PROGRESS && (
            <Text variant="text2">
              Currently the PDF file from the uploaded Pro Forma is getting
              generated. Please wait until the generation has finished.
            </Text>
          )}
          {proformaPDF?.status === ProformaPDFFileStatus.FAILED && (
            <Text variant="text2">
              The generation of the PDF file has failed.
            </Text>
          )}
        </>
      ) : (
        <Text variant="text2">
          No PDF file has been created from the uploaded Pro Forma.
        </Text>
      )}
    </AccordionDetails>
  </Accordion>
);

export default AppendixAccordion;
